import React from "react";
import "./Resume.css";
import box from "../../assets/box-cut.svg";

const Resume = () => {
  return (
    <div className="ju">
      <div className="resume-section">
        <div className="resume">
          <img
            className="jj"
            decoding="async"
            data-aos="fade-up"
            data-aos-offset="50"
            src={box}
            alt="Crossed out box illustration"
            data-rellax-speed="-1"
          ></img>

          <h5 id="career" className="h52">
            My Career Voyage
          </h5>
          <h2 className="lh22">
            <strong>From Dreams to</strong> Reality
          </h2>
          <ul className="timeline">
            <li>
              <div className="direction-l">
                <div className="flag-wrapper">
                  <span className="flag">GUVI</span>
                  <span className="time-wrapper">
                    <span className="time">JUL 2021</span>
                  </span>
                </div>
                <div className="desc">
                  Achieved a top 100 ranking for coding in India.
                </div>
              </div>
            </li>

            {/* <!-- Item 3 --> */}
            <li>
              <div className="direction-r">
                <div className="flag-wrapper">
                  <span className="flag">INTERN</span>
                  <span className="time-wrapper">
                    <span className="time">DEC 2021</span>
                  </span>
                </div>
                <div className="desc">
                  Accomplished a Web Scraping Internship at KG IT Services.
                </div>
              </div>
            </li>

            <li>
              <div className="direction-l">
                <div className="flag-wrapper">
                  <span className="flag">INTERN</span>
                  <span className="time-wrapper">
                    <span className="time">JAN - MAR 2022</span>
                  </span>
                </div>
                <div className="desc">
                  Doctor Booking Platform for Dr.Bannerjee Cures,
                  Bangalore.
                </div>
              </div>
            </li>

            <li>
              <div className="direction-r">
                <div className="flag-wrapper">
                  <span className="flag">FREELANCER</span>
                  <span className="time-wrapper">
                    <span className="time">JUN - JUL 2022</span>
                  </span>
                </div>
                <div className="desc">
                  Built a Custom ERP System for LITVIK SOFTWARE PVT LTD.
                </div>
              </div>
            </li>

            <li>
              <div className="direction-l">
                <div className="flag-wrapper">
                  <span className="flag">STAR PERFORMER</span>
                  <span className="time-wrapper">
                    <span className="time">OCT 2022</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Incentive Received for Outstanding Coding Performance.
                </div>
              </div>
            </li>

            <li>
              <div className="direction-r">
                <div className="flag-wrapper">
                  <span className="flag">FOODCHEF</span>
                  <span className="time-wrapper">
                    <span className="time">DEC - JAN 2023</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Built a Food Delivery Website.
                </div>
              </div>
            </li>

            <li>
              <div className="direction-l">
                <div className="flag-wrapper">
                  <span className="flag">TRADE-A-THON </span>
                  <span className="time-wrapper">
                    <span className="time"> FEB 2023</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Ranked Top 3% in the Trading
                  Competition organized by IIT Palakkad.
                </div>
              </div>
            </li>

            <li>
              <div className="direction-r">
                <div className="flag-wrapper">
                  <span className="flag">UI/UX TITLE WINNER</span>
                  <span className="time-wrapper">
                    <span className="time"> MAR 2023</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Took the Crown in the UI/UX Competition organized by
                  Coimbatore Institute of Technology (Edutech).
                </div>
              </div>
            </li>

            <li>
              <div className="direction-l">
                <div className="flag-wrapper">
                  <span className="flag">CSS BATTLE FINALIST</span>
                  <span className="time-wrapper">
                    <span className="time"> MAR 2023</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  CSS Battle Finalist Recognized by Coimbatore Institute of
                  Technology.
                </div>
              </div>
            </li>

            <li>
              <div className="direction-r">
                <div className="flag-wrapper">
                  <span className="flag">BULLSIGHT</span>
                  <span className="time-wrapper">
                    <span className="time"> APR - JUN 2023</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Developed a Platform for Real-time Stock Price Analysis and
                  Tools for Stocks, Crypto and Forex.
                </div>
              </div>
            </li>

            <li>
              <div className="direction-l ll">
                <div className="flag-wrapper">
                  <span className="flag">Placement Management</span>
                  <span className="time-wrapper">
                    <span className="time"> JUN - AUG 2023</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Developed the Placement Management System for CDC (KPRIET)
                </div>
              </div>
            </li>

            <li>
              <div className="direction-r">
                <div className="flag-wrapper">
                  <span className="flag">FREELANCER</span>
                  <span className="time-wrapper">
                    <span className="time"> AUG - OCT 2023</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Built custom software for SWARM System (KG IT Services)
                </div>
              </div>
            </li>

            <li>
              <div className="direction-l">
                <div className="flag-wrapper">
                  <span className="flag">GRAD OFFER</span>
                  <span className="time-wrapper">
                    <span className="time"> OCT 2023</span>
                  </span>
                </div>
                <div className="desc">
                  Received a grad job offer at Hewlett Packard Enterprise (HPE)
                </div>
              </div>
            </li>

            <li>
              <div className="direction-r">
                <div className="flag-wrapper">
                  <span className="flag">FREELANCER</span>
                  <span className="time-wrapper">
                    <span className="time"> OCT 2023 - FEB 2024</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Built a business portfolio for AARRYAMAAN.
                </div>
              </div>
            </li>

            <li>
              <div className="direction-l">
                <div className="flag-wrapper">
                  <span className="flag">INTERN</span>
                  <span className="time-wrapper">
                    <span className="time"> FEB 2024 - AUG 2024</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Started my SDE Internship at Hewlett Packard Enterprise
                  (HPE)
                </div>
              </div>
            </li>

            <li>
              <div className="direction-r">
                <div className="flag-wrapper">
                  <span className="flag">SEBI Investor</span>
                  <span className="time-wrapper">
                    <span className="time"> APR 2024</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Successfully passed the NISM SEBI Investor Certification
                  Examination. (Validity: 2 Years)
                </div>
              </div>
            </li>

            <li>
              <div className="direction-l">
                <div className="flag-wrapper">
                  <span className="flag">FTE</span>
                  <span className="time-wrapper">
                    <span className="time"> SEP 2024</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Began my full-time role as SDE-1 at Hewlett Packard Enterprise (HPE){" "}
                </div>
              </div>
            </li>

            <li>
              <div className="direction-r">
                <div className="flag-wrapper">
                  <span className="flag">Equity Milestone</span>
                  <span className="time-wrapper">
                    <span className="time"> Nov 2025</span>
                  </span>
                </div>
                <div className="desc">
                  {" "}
                  Grew personal equity to 2M (excluding global markets & unlisted space), contributing to a 52M asset allocation.
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Resume;
